<template>
  <v-dialog v-model="visible" persistent max-width="600px" scrollable>
    <v-form ref="form" @submit.prevent="handleSubmit">
      <v-card :loading="loading">
        <v-card-title>
          <span class="headline">{{ $t("modal.addCaseGroup.title") }}</span>
        </v-card-title>
        <v-card-subtitle> {{ $t("modal.addCaseGroup.subtitle") }} </v-card-subtitle>

        <v-card-text>
          <v-container>
            <v-alert v-if="error" border="left" colored-border type="error" elevation="2">
              {{ error }}
            </v-alert>

            <v-row>
              <!-- case group name -->
              <v-col cols="6">
                <v-text-field style="font-size: 1em" :maxlength="20" :label="$t('label.name')" v-model="caseGroup.name" :rules="[rules.required]" />
              </v-col>
              <v-col cols="6">
                <v-select style="font-size: 1em" label="Default Assignee" clearable v-model="caseGroup.defaultAssignedUser" :items="users" :item-text="(item) => { return getTextForUserSelect(item); }" return-object />
              </v-col>
              <v-col cols="12">
                <v-select style="font-size: 1em" label="Receive Open Case Alerts" multiple v-model="caseGroup.alertUsers" :items="users" item-text="email" return-object />
              </v-col>
              <v-col cols="12">
                <v-select clearable v-model="caseGroup.groupScreeningFrequency" :items="groupFrequencyOptions" style="font-size: 1em" label="Ongoing Screening Frequency"></v-select>
              </v-col>
              <v-col cols="12">
                <p>
                  <span class="font-weight-bold">Additional Validation</span><br />
                  Periodically validate case information.
                </p>
                <!-- VAT -->
                <v-checkbox dense v-model="caseGroup.vatValidationEnabled">
                  <template v-slot:label>
                    <div>
                      <span class="font-weight-bold">VAT &nbsp;</span>Validate EU VAT data against
                      <v-tooltip bottom max-width="400">
                        <template v-slot:activator="{ on }">
                          <a target="_blank" @click.stop v-on="on">
                            VIES.
                          </a>
                        </template>
                        <b>VIES</b> (VAT Information Exchange System) is a VAT number validation service provided by the European Commission.
                      </v-tooltip>
                    </div>
                  </template>
                </v-checkbox>

                <!-- TIN -->
                <v-checkbox dense v-model="caseGroup.tinValidationEnabled">
                  <template v-slot:label>
                    <div>
                      <span class="font-weight-bold">EU TIN &nbsp;</span>Check EU TIN data for
                      <v-tooltip bottom max-width="400">
                        <template v-slot:activator="{ on }">
                          <a target="_blank" @click.stop v-on="on">
                            correctness.
                          </a>
                        </template>
                        Validate the structure and syntax of TIN data against services provided by the European Commission.
                      </v-tooltip>
                    </div>
                  </template>
                </v-checkbox>
              </v-col>
              <v-col cols="12">
                <v-textarea :maxlength="75" style="font-size: 1em" v-model="caseGroup.description" :label="$t('label.description')" :rules="[rules.required]" />
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn color="blue darken-1" text @click="onCancel">{{
            $t("label.cancel")
            }}</v-btn>
          <v-btn color="blue darken-1" type="submit" :loading="loading">{{
            $t("label.save")
            }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>

<script>
import { mapActions } from "vuex";
import { getTextForUserSelect } from "../../utils/userUtils";
export default {
  name: "AddCaseGroup",
  props: {
    groupFrequencyOptions: {},
    visible: {
      type: Boolean,
      default: false,
    },
    users: {},
  },
  data() {
    return {
      caseGroup: {
        user: {},
      },
      loading: false,
      error: "",
      rules: {
        required: (value) => !!value || "Required.",
      },
    };
  },
  methods: {
    ...mapActions(["addCaseGroup", "setGlobalAlert"]),
    getTextForUserSelect,
    //submit
    async handleSubmit() {
      if (!this.$refs.form.validate()) {
        return false;
      }

      this.error = null;
      this.loading = true;

      try {
        await this.addCaseGroup(this.caseGroup);
        this.$emit("onClose"); // TODO Move this to the bottom of the block to be cleaner
        this.caseGroup = {};
        this.setGlobalAlert({
          alert: true,
          color: "green",
          alertMessage: "Case Group Created",
        });
      } catch (e) {
        // TODO consider using globalAlert to be consistant with rest of app
        this.error = this.$t("error.general.unhandled");
      }

      this.loading = false;
      this.$refs.form.reset();
    },
    onCancel() {
      this.$emit("onClose");
      this.$refs.form.reset();
      this.caseGroup = {};
    },
  },
};
</script>